import { getObjectName } from 'utils/utils'

export const INITIAL_STATE = {
    name: null,
    description: null,
    image_url: null,
    desktop_image_url: null,
    mobile_image_url: null,
    date_start: null,
    date_expired: null,
    status: null,
    products: [],
}

export const GET_FIELD_NAME = {
    name: 'Nama flash sale',
    description: 'Deskripsi flash sale',
    image_url: 'Icon flash sale',
    desktop_image_url: 'Background flash sale desktop',
    mobile_image_url: 'Background flash sale mobile',
    date_start: 'Waktu mulai',
    date_expired: 'Waktu berakhir',
    products: 'Product item',
}

export const GET_ITEM_FIELD_NAME = {
    product_id: 'Produk',
    price: 'Harga flash sale',
    stock_quantity: 'Stok produk',
}

export const ITEM_FIELD_NAME_DETAIL = {
    ...GET_ITEM_FIELD_NAME,
    limit_purchase: 'Limit pembelian',
}

export const SECTION_FIELDS = {
    general_data: getObjectName(INITIAL_STATE, 0, 8),
    product_item: ['products_detail'],
}
